import PageMeta from "../../components/common/PageMeta";
import EmailContent from "../../components/email/EmailContent";

export default function EmailInbox() {
  return (
    <>
      <PageMeta
        title="React.js Inbox Dashboard | TailAdmin - React.js Admin Dashboard Template"
        description="This is React.js Inbox Dashboard page for TailAdmin - React.js Tailwind CSS Admin Dashboard Template"
      />
      <EmailContent />
    </>
  );
}
